import LicenseLimitExceeded from '@auth/LicenseLimitExceeded'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/login/license-limit')({
  component: RouteComponent,
  validateSearch: z.object({
    to: z.string().optional(),
  }),
})

function RouteComponent() {
  const { to } = Route.useSearch()

  return <LicenseLimitExceeded to={to} />
}
